module.exports = "<p class=form-control-static> <a ui-sref=\"app.poi({id: $ctrl.poi.id, revision: 0})\" ng-if=$ctrl.poi> <span class=icon-align-baseline ng-class=$ctrl.getIcon()></span> {{ $ctrl.poi.display_name | appTranslateField: $ctrl.poi.main_lang }} </a> </p> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/poireference/partial.html
// module id = 551
// module chunks = 0